import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { ContactService } from '../../services/contact.service';
import { CRMService } from '../../services/crm.service';
import { EmployeeService } from '../../services/employees.service';
import { OrderService } from '../../services/order.service';
import { NotificationService } from '../../services/notification.service';
import { UtilService } from '../../services/util.service';
import {
    ActionType,
    Customer,
    CustomerAction,
    CustomerStatus,
    CustomerStatusChecklist,
    CustomerStatusChecklistMap,
    DateDimension,
    Employee,
    Opportunity,
    SearchCustomerContact,
    SearchCustomerTeam
} from '../../models/models';

@Component({
    selector: 'customer-action-form',
    templateUrl: './customer-action-form.component.html',
    standalone: false
})
export class CustomerActionForm implements OnChanges {
    @Input() customerActionID: number = 0;
    @Input() customerID: number = 0;
    @Input() opportunityID: number = 0;
    @Input() opportunity: Opportunity = {} as Opportunity;
    @Output() onRefresh = new EventEmitter<any>();

    public customerAction: CustomerAction = {} as CustomerAction;
    public employeeList: Employee[] = [];
    public actionTypeList: ActionType[] = [];
    public customerStatusList: CustomerStatus[] = [];
    public opportunityList: Opportunity[] = [];
    public contactList: SearchCustomerContact[] = [];
    public customer: Customer = {} as Customer;
    public selectedContact: SearchCustomerContact = {} as SearchCustomerContact;
    private customerStatusChecklistMapList: CustomerStatusChecklistMap[] = [];
    private customerStatusChecklist: CustomerStatusChecklist[] = [];
    private searchCustomerTeamList: SearchCustomerTeam[] = [];
    private followUpDefaultDays: number = 2;
    private customerStatusID: number = 0;
    //public commentText: string = "";
    public isCRMAdmin: boolean = false;
    public isAddContact: boolean = false;
    public isEditContact: boolean = false;
    public isExpectedCloseDateValid: boolean = true;

    constructor(private applicationControlService: ApplicationControlService, private contactService: ContactService,
        private crmService: CRMService, private employeeService: EmployeeService, private orderService: OrderService,
        private notificationService: NotificationService, private utilService: UtilService) {
    }

    ngOnInit() {
        this.applicationControlService.getApplicationControlsByAppName("DefaultFollowupDays").subscribe(result => {
            if (result.length > 0) {
                this.followUpDefaultDays = parseInt(result[0].appSettingValue);
            }
        });
        this.isCRMAdmin = this.getIsCRMAdmin();
        this.getActionTypes();
        this.getCustomerStatusChecklist();
        this.getEmployees();
        //console.log("ngOnInit", this.opportunityID, this.customerID);
    }

    ngOnChanges() {
        this.getContacts();
        this.getCustomerAction();
        this.getOpportunities();
        this.getSearchCustomerTeam();
        //console.log("ngOnChanges", this.opportunity);
    }

    public getIsCRMAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('CRM Admin') > -1) return true;
        }

        return false;
    }

    private getActionTypes() {
        this.crmService.getActionTypes().subscribe(result => {
            this.actionTypeList = result.filter(t => t.retiredInd != true);
            //this.setOpportunityValues();
        });
    }

    private getCustomerStatuses() {
        this.crmService.getCustomerStatuses().subscribe(result => {
            this.customerStatusList = result;
            var currentStatus = this.customerStatusList.find(t => t.customerStatusId == this.customer.customerStatusId)!;
            this.customerStatusList = this.customerStatusList.filter(t => t.stage > currentStatus.stage && t.retiredInd != true && t.abbreviation != "Customer");
            this.customerStatusList = this.customerStatusList.sort((left, right): number => {
                if (left.stage < right.stage) return -1;
                if (left.stage > right.stage) return 1;
                return 0;
            });
            var dsqStatus = this.customerStatusList.find(t => t.abbreviation == "Disqualified")!;
            if (!this.isCRMAdmin && dsqStatus != undefined) {
                this.customerStatusList = this.customerStatusList.filter(t => t.customerStatusId != dsqStatus.customerStatusId);
            }
        });
    }

    private getCustomerStatusChecklistMaps() {
        this.crmService.getCustomerStatusChecklistMapsByCustomerId(this.customerID).subscribe(result => {
            this.customerStatusChecklistMapList = result;
        });
    }

    private getCustomerStatusChecklist() {
        this.crmService.getCustomerStatusChecklists().subscribe(result => {
            this.customerStatusChecklist = result;
        });
    }

    private getEmployees() {
        this.employeeService.getEmployeesByGroupName('crm user').subscribe(result => {
            this.employeeList = result;
        });
    }

    private getContacts() {
        //this.contactList = [];
        //if ((this.customer == null || this.customer.customerId < 1) && this.opportunityGroup.controls['customerCtrl'].value == '') return;

        //var customerId = (this.customer == null || this.customer.customerId < 1)
        //    ? (this.opportunityGroup.controls['customerCtrl'].value as CustomerListResult).customerId
        //    : this.customer.customerId;

        this.crmService.getCustomerById(this.customerID).subscribe(result => {
            this.customer = result;
            this.customerStatusID = this.customer.customerStatusId;
            this.customerAction.erpCompanyID = this.customer.customerCode;
            this.getCustomerStatuses();
            this.getCustomerStatusChecklistMaps();
        });

        this.contactService.getSearchContactByCustomerID(this.customerID).subscribe(result => {
            this.contactList = result.resultCollection;
            this.contactList = this.contactList.sort((left, right): number => {
                if (left.contactName < right.contactName) return -1;
                if (left.contactName > right.contactName) return 1;
                return 0;
            });
        });
    }

    private getOpportunities() {
        if (this.customerID > 0) {
            this.crmService.getOpportunitiesByCustomerId(this.customerID).subscribe(result => {
                this.opportunityList = result;
                this.opportunityList = this.opportunityList.sort((left, right): number => {
                    if (left.notes < right.notes) return -1;
                    if (left.notes > right.notes) return 1;
                    return 0;
                });
            });
        }
    }

    private getCustomerAction() {
        if (this.customerActionID > 0) {
            this.crmService.getCustomerActionByid(this.customerActionID).subscribe(result => {
                this.customerAction = result;
                this.customerAction.eventDate = new Date(this.customerAction.eventDate);
                if (this.customerAction.followUpDate != null) {
                    this.customerAction.followUpDate = new Date(this.customerAction.followUpDate);
                }
                //if (this.customerAction.comment) {
                //    this.commentText = this.customerAction.comment.commentText;
                //}
            });
        }
        else {
            var employeeID: number = parseInt(localStorage.getItem('EmployeeId')!);
            this.customerAction = {
                customerActionID: 0,
                customerID: this.customerID,
                actionTypeID: 0,
                contactID: 0,
                erpCompanyID: "",
                commentID: 0,
                eventDate: new Date(),
                modifiedDate: new Date(),
                transDate: new Date(),
                followUpDate: new Date(),
                followUpInd: false,
                followUpEmployeeID: 0,
                parentCustomerActionID: 0,
                createEmployeeId: employeeID,
                futureActionRequiredInd: false,
                opportunityId: this.opportunityID,
                //actionType: {} as ActionType,
                //comment: {} as Comment,
                customerActionNotes: "",
                //createEmployee: {} as Employee,
                notes: ""
            };
            //this.customerAction.comment.commentId = 0;
            //this.customerAction.comment.commentText = "";
        }
    }

    public contactChange(evt: any) {
        //console.log("contactChange", evt.target.value, this.offer.quoteOrderLine.carrierContactId);
        var contactID = evt.target.value;
        if (contactID != "") {
            this.selectedContact = this.contactList.find(c => c.contactID == contactID)!;
            this.customerAction.contactID = contactID;
        }
        else {
            this.selectedContact = {} as SearchCustomerContact;
        }
        if (this.selectedContact.phone == undefined) {
            this.selectedContact.phone = "";
        }
        if (this.selectedContact.email == undefined) {
            this.selectedContact.email = "";
        }
        //this.validate(true);
    }

    public addContact(contactType) {
        this.isAddContact = true;
    }

    public editContact(contactType) {
        this.isEditContact = true;
    }

    public refreshContacts(contactID: number, contactType: string) {
        this.isAddContact = false;
        this.isEditContact = false;
        this.customerAction.contactID = contactID;
        //console.log("refreshContacts", contactID, contactType);
        this.getContacts();
    }

    private getSearchCustomerTeam() {
        this.utilService.isLoading = true;
        // Get account manager for assigned follow up
        this.crmService.getSearchCustomerTeamByCustomerID(this.customerID).subscribe(result => {
            this.utilService.isLoading = false;
            this.searchCustomerTeamList = result.resultCollection;
            this.searchCustomerTeamList = this.searchCustomerTeamList.filter(t => t.isEmployeeActive == true && t.customerTeamTypeAbbreviation == "AM");
        });
    }

    public toggleFollowUp() {
        if (this.customerAction.followUpInd == true) {
            // Use DateDimension table to get business days and exclude holidays
            this.utilService.isLoading = true;
            this.utilService.getDateDimensionBusinessDaysAfterDate(new Date(), this.followUpDefaultDays).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.resultCollection.length > 0) {
                    var dateDim: DateDimension = result.resultCollection[0];
                    this.customerAction.followUpDate = new Date(dateDim.date);
                }
                else {
                    this.customerAction.followUpDate = this.utilService.addDays(new Date(), this.followUpDefaultDays);
                }
                if (this.searchCustomerTeamList.length > 0) {
                    this.customerAction.followUpEmployeeID = this.searchCustomerTeamList[0].employeeID;
                }
            });
        }
    }

    public dateChanged(dateType: string) {

    }

    public save() {
        this.utilService.isLoading = true;
        //this.customerAction.comment.commentText = this.commentText;
        //console.log("save", this.customer.customerStatusId, this.customerStatusID, this.customerAction);
        var customerAction = Object.assign({}, this.customerAction);
        var isJumpCustomerRun: boolean = false;
        this.crmService.saveCustomerAction(this.customerAction).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                if (this.customer.customerStatusId != this.customerStatusID) {
                    // Jump status selected
                    var employeeID: number = parseInt(localStorage.getItem('EmployeeId')!);
                    var checkListItems: CustomerStatusChecklist[] = this.customerStatusChecklist.filter(t => t.customerStatusId == this.customer.customerStatusId)!;
                    for (var i = 0; i < checkListItems.length; i++) {
                        var customerStatusChecklistID: number = 0;
                        var idx: number = -1;
                        if (checkListItems.length > 0) {
                            customerStatusChecklistID =  checkListItems[i].customerStatusChecklistID;
                            idx = this.customerStatusChecklistMapList.findIndex(t => t.customerStatusChecklistId == customerStatusChecklistID);
                        }
                        var checkListMap: CustomerStatusChecklistMap = {} as CustomerStatusChecklistMap;
                        if (idx < 0) {
                            checkListMap.customerStatusChecklistMapID = 0;
                            checkListMap.customerID = this.customerID;
                            checkListMap.customerStatusChecklistId = customerStatusChecklistID;
                            checkListMap.createdByEmployeeID = employeeID;
                            checkListMap.createdDate = new Date();
                        }
                        else {
                            checkListMap = Object.assign({}, this.customerStatusChecklistMapList[idx]);
                        }
                        checkListMap.completed = true;
                        checkListMap.completedDate = new Date();
                        checkListMap.lastModifiedByEmployeeId = employeeID;
                        checkListMap.notes = customerAction.customerActionNotes;
                        //console.log("jumpCustomerStatus:saveCustomerStatusChecklistMap", checkListMap);
                        this.utilService.isLoading = true;
                        this.crmService.saveCustomerStatusChecklistMap(checkListMap).subscribe(result2 => {
                            this.utilService.isLoading = false;
                            var updatedChecklistMap = result2;
                            if (i == checkListItems.length && isJumpCustomerRun == false) {
                                isJumpCustomerRun = true;
                                this.crmService.jumpCustomerStatus(checkListMap, this.customer.customerStatusId).subscribe(result3 => {
                                    var updatedStatusList = result3.resultCollection;
                                    //console.log("jumpCustomerStatus:updatedStatusList", checkListMap, updatedStatusList);
                                    this.onRefresh.emit();
                                });
                            }
                            //console.log("jumpCustomerStatus:updatedChecklistMap", checkListMap, updatedChecklistMap);
                        });
                    }
                    //if (checkList != null) {
                    //}
                    //else {
                    //    this.notificationService.showError("Jump Status: Status does not have a checklist step for it.", "ERROR: Jump Status");
                    //    this.onRefresh.emit();
                    //}

                }
                else {
                    this.onRefresh.emit();
                }
            } else {
                this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
            }
        });

        this.customerAction = {} as CustomerAction;
    }

    public cancel() {
        this.onRefresh.emit();
    }
}
